<template>
  <div class='homePage'>
    <div class="idx_banner">
      <div class="idx_slider_wrapper">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="item in chartList" :key="item.id">
            <a :href="item.link">
              <img :src="item.image_url">
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <ul class="idx_slider_nav">

      </ul>
    </div>
      <div class="main">
        <div class="index-list comWidth">
          <ul>
            <li v-for="(list, index) in recommend">
              <div @click="link(list.link)">
                <img :src="list.image_url" alt="">
              </div>
            </li>
            <!--<li>-->
              <!--<router-link :to="{name:'IntroduceTwo'}" tag="a">-->
                <!--<img src="../assets/1500599647034878552.jpg" alt="">-->
              <!--</router-link>-->
            <!--</li>-->
            <!--<li>-->
              <!--<router-link to="/introduceThree">-->
                <!--<img src="../assets/1499322353378333311.jpg" alt="冬虫夏草怎么吃">-->
              <!--</router-link>-->
            <!--</li>-->

            <!--<li>-->
              <!--<router-link to="/introduceFour">-->
                <!--<img src="../assets/1499322344985251756.jpg" alt="冬虫夏草的的功效与作用">-->
              <!--</router-link>-->
            <!--</li>-->

          </ul>
        </div>
    </div>
  </div>
</template>

<script>
  //api
  import { advertising } from '@/api/other';
  export default {
    name: 'HomePage',
    data () {
      return {
        imgUrl: [
          'https://www.verygrass.mo/data/afficheimg/1500599622832110626.jpg',
          'https://www.verygrass.mo/data/afficheimg/1503296895833788524.jpg',
          'https://www.verygrass.mo/data/afficheimg/1517991047491699913.jpg',
          'https://www.verygrass.mo/data/afficheimg/1522823813416602706.jpg'],
        //首页轮播
        chartList:[],
        //首页推荐
        recommend:[],
        // 广告链接
        Introduce: ['IntroduceOne','IntroduceTwo','introduceThree','introduceFour'],
      }
    },
    methods:{
      link(val) {
        window.open(val)
      },
        /*获取首页轮播数据*/
        getChart(){
            var obj = {ad_site:0,type:0};
          advertising(obj).then( res=>{
              this.chartList = res.data.data;
          })
      },

      /*获取广告推荐*/
      advertisement(){
        var obj = {ad_site:1,type:0};
        advertising(obj).then( res=>{
          this.recommend = res.data.data;
          console.log(this.recommend)
        })
      }
    },
    created(){
        //轮播列表
        this.getChart();
        //广告推荐
        this.advertisement()
      window.scrollTo(0,0)
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../css/homePage.less";
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue